export default __webpack_public_path__ + "static/logo-bd31ac98f22833b7d5183ba1228dacb8.png";